export default __webpack_public_path__ + "static/mastercard-b16c0047997356ecfebb1386441b10de.png";